<div class="dialog">
    <div class="dialog-header">
        <h3 *ngIf="!data?.isSeller">{{ 'SALES_DOCUMENT|Kupujący:' | translate }}</h3>
        <h3 *ngIf="data?.isSeller">{{ 'SALES_DOCUMENT|Sprzedający:' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2 w-100">

            <h3 class="w-100" >{{ 'SALES_DOCUMENT|Dane kontrahenta:' | translate }}</h3>

            <div class="w-100" >

                <div
                    *ngIf="data.client?.companyName"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma:' | translate }}</span>
                    <span class="w-70 text-left pl-1"> {{ data.client?.companyName }} </span>
                </div>
                <div
                    *ngIf="data.client?.companyVatNr"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Nip:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.client.companyVatNr }}</span>
                </div>
                <div
                    *ngIf="data.client?.companyVatNrEu"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|VAT-EU:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.client.companyVatNrEu }}</span>
                </div>
                <div
                    *ngIf="data.client?.invoiceEmail"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase" >{{ 'CONTACT|E-mail kontaktowy:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.client?.invoiceEmail }}</span>
                </div>
                <div
                    *ngIf="data.client?.invoicePhone"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon kontaktowy:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.client.invoicePhone }}</span>
                </div>
            </div>

            <ng-container *ngIf="data.client?.firstName || data.client?.lastName || data.client?.email || data.client?.phoneNumber">
                <h3 class="w-100" >{{ 'COMPANY|Osoba kontaktowa' | translate }}</h3>
                <div class="w-100" >
                    <div
                        *ngIf="data.client?.firstName && data.client?.lastName"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Osoba kontaktowa:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client.firstName }} {{ data.client.lastName }} </span>
                    </div>
                    <div
                        *ngIf="data.client?.email"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase" >{{ 'CONTACT|E-mail:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.client?.email }}</span>
                    </div>
                    <div
                        *ngIf="data.client?.phoneNumber"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase" >{{ 'CONTACT|Telefon:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.client?.phoneNumber }}</span>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="data.client?.delivery">

                <h3
                    *ngIf="data.client?.invoiceFromDelivery && !data.client?.otherContact"
                    class="w-100"
                >
                    {{ 'CONTACT|Adres:' | translate }}
                </h3>

                <h3
                    *ngIf="data.client?.otherContact"
                    class="w-100"
                >
                    {{ 'CONTACT|Dane dostawy:' | translate }}
                </h3>

                <h3
                    *ngIf="!data.client?.invoiceFromDelivery && !data.client?.otherContact"
                    class="w-100"
                >
                    {{ 'CONTACT|Dane dostawy i wysyłki dokumentów:' | translate }}
                </h3>

                <div class="w-100" >

                    <div
                        *ngIf="data.client?.delivery?.addressLine1 || data.client?.delivery?.addressLine2"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Adres' | translate }}</span>
                        <span class="w-70 text-left pl-1">

                            <ng-container *ngIf="data.client?.delivery?.addressLine1">{{ data.client?.delivery?.addressLine1 }}<br></ng-container>
                            <ng-container *ngIf="data.client?.delivery?.addressLine2">{{ data.client?.delivery?.addressLine2 }}<br></ng-container>

                        </span>
                    </div>

                    <div
                        *ngIf="data.client?.delivery?.postalCode && data.client?.delivery?.city"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kod + miejscowość' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.client?.delivery?.postalCode }} {{ data.client?.delivery?.city }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.delivery?.countryId && data.client?.delivery?.regionId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Województwo' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getRegionName(data.client?.delivery?.countryId, data.client?.delivery?.regionId) }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.delivery?.countryId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kraj' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getCountry(data.client?.delivery?.countryId)?.name }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.deliveryEmail"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail dostawy:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client?.deliveryEmail }} </span>
                    </div>

                    <div
                        *ngIf="data.client?.deliveryPhone"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon dla kuriera:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client?.deliveryPhone }} </span>
                    </div>

                </div>

            </ng-container>

            <ng-container *ngIf="!data.client?.invoiceFromDelivery || data.client?.otherContact">


                <h3 class="w-100" >{{ 'CONTACT|Dane do faktury:' | translate }}</h3>

                <div class="w-100" >

                    <div
                        *ngIf="data.client?.companyName"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{  data.client.companyName }} </span>
                    </div>

                    <div
                        *ngIf="data?.client?.companyVatNr || data?.client?.companyVatNrEu"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Nip' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data?.client?.companyVatNr || data?.client?.companyVatNrEu }} </span>
                    </div>

                    <div
                        *ngIf="data.client?.invoice?.addressLine1 || data.client?.invoice?.addressLine2"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Adres' | translate }}</span>
                        <span class="w-70 text-left pl-1">

                            <ng-container *ngIf="data.client?.invoice?.addressLine1">{{ data.client?.invoice?.addressLine1 }}<br></ng-container>
                            <ng-container *ngIf="data.client?.invoice?.addressLine2">{{ data.client?.invoice?.addressLine2 }}<br></ng-container>

                        </span>
                    </div>

                    <div
                        *ngIf="data.client?.invoice?.postalCode && data.client?.invoice?.city"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kod + miejscowość' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.client?.invoice?.postalCode }} {{ data.client?.invoice?.city }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.invoice?.countryId && data.client?.invoice?.regionId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Województwo' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getRegionName(data.client?.invoice?.countryId, data.client?.invoice?.regionId) }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.invoice?.countryId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kraj' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getCountry(data.client?.invoice?.countryId)?.name }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.invoiceEmail"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail na fakturze:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client.invoiceEmail }} </span>
                    </div>

                    <div
                        *ngIf="data.client?.invoicePhone"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon na fakturze:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client.invoicePhone }} </span>
                    </div>

                </div>

            </ng-container>

            <ng-container *ngIf="data.client?.otherContact">

                <h3 class="w-100" >{{ 'CONTACT|Adres do wysyłki dokumentów:' | translate }}</h3>

                <div class="w-100" >

                    <div
                        *ngIf="data.client?.companyName"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{  data.client.companyName }} </span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDelivery?.addressLine1 || data.client?.billingDelivery?.addressLine2"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Adres' | translate }}</span>
                        <span class="w-70 text-left pl-1">

                            <ng-container *ngIf="data.client?.billingDelivery?.addressLine1">{{ data.client?.billingDelivery?.addressLine1 }}<br></ng-container>
                            <ng-container *ngIf="data.client?.billingDelivery?.addressLine2">{{ data.client?.billingDelivery?.addressLine2 }}<br></ng-container>

                        </span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDelivery?.postalCode && data.client?.billingDelivery?.city"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kod + miejscowość' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.client?.billingDelivery?.postalCode }} {{ data.client?.billingDelivery?.city }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDelivery?.countryId && data.client?.billingDelivery?.regionId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Województwo' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getRegionName(data.client?.billingDelivery?.countryId, data.client?.billingDelivery?.regionId) }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDelivery?.countryId"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Kraj' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ getCountry(data.client?.billingDelivery?.countryId)?.name }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDeliveryEmail"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail dokumenty:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client.billingDeliveryEmail }}</span>
                    </div>

                    <div
                        *ngIf="data.client?.billingDeliveryPhone"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon dokumenty:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ data.client.billingDeliveryPhone }} </span>
                    </div>

                </div>

            </ng-container>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>